import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/gopath/src/github.com/rumblefrog/source-chat-relay/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "filters"
    }}>{`Filters`}</h1>
    <p>{`The filter is useful if you wish to drop certain messages whether it be commands or just unsolicited messages`}</p>
    <p>{`To enable filters:`}</p>
    <ol>
      <li parentName="ol">{`Set `}<inlineCode parentName="li">{`Filter`}</inlineCode>{` to `}<inlineCode parentName="li">{`true`}</inlineCode>{` in `}<inlineCode parentName="li">{`config.toml`}</inlineCode></li>
      <li parentName="ol">{`Create a `}<inlineCode parentName="li">{`filter.txt`}</inlineCode>{` in the same directory as the relay server binary`}</li>
      <li parentName="ol">{`Populate each line of the file with a regex expression (`}<strong parentName="li">{`Note`}</strong>{`: if you have a blank line, it will count as a regex and will filter everything out)`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      